// extracted by mini-css-extract-plugin
export default {"summaryContainer":"SummaryPanel_summaryContainer__IMCOv","chapter":"SummaryPanel_chapter__WFnEY"};